import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  ArrowLeftIcon,
  ChevronRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { UpdateEmail } from "./UpdateEmail";
import { UpdateWhatsApp } from "./UpdateWhatsApp";
import { BasicInfoService } from "../../../../services/basicinfo/basicinfo.service";
import { WarningAlert } from "../../../alerts/warningAlert";

export function UpdateData(props) {
  const [open, setOpen] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [isOpenAlert, setIsOpenAlert] = useState(false);

  const channels = [
    {
      disclosure: <UpdateWhatsApp />
    },
    {
      disclosure: <UpdateEmail />
    },
  ];

  const hasCreditActive = async () => {
    try {
      let rsp = await BasicInfoService.hasCreditActive(localStorage.getItem('doc'));
      let { message } = rsp;
      return message;
    } catch (error) {
      console.log(error);
      return error?.message;
    }
  }

  const handleToggleDialogFeedback = (message, isOpen) => {
    setMessageAlert(message);
    setIsOpenAlert(isOpen);
    return;
  }

  const handleOpenDisclosure = async () => {
    try {
      handleToggleDialogFeedback("", false);
      let hasActiveCredit = await hasCreditActive();
      if (hasActiveCredit) {
        handleToggleDialogFeedback("No puedes cambiar tus datos mientras tengas un crédito vigente", true);
        return;
      } else {
        setOpen(true);
      }
    } catch (error) {
      console.log(error);
      handleToggleDialogFeedback("Ocurrió un error, intenta más tarde.", true);
      return;
    }
  }

  return (
    <>

      {isOpenAlert && (
        <WarningAlert isOpen={isOpenAlert} message={messageAlert}></WarningAlert>
      )}

      <div className="cursor-pointer" onClick={handleOpenDisclosure} href="#">
        <div className="relative">
          <div>Actualizar</div>
        </div>
      </div>

      <Dialog open={open} onClose={setOpen} className="relative z-40">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-darkBgLight bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Actualizar datos</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          ¿Cuál es el dato que deseas actualizar?
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white">
                    <div className="">
                      {channels.map((channel) => (
                        <>
                          <div key={channel.name}>
                            <a
                              href={channel.href}
                              className="group flex justify-between w-full gap-2 rounded-md px-4 py-6"
                            >
                              {channel.disclosure ? (
                                <div className="relative w-full">
                                  {channel.disclosure}
                                </div>
                              ) : (
                                <></>
                              )}
                              {channel.name ? (
                                <div className="flex w-full gap-2 py-1">
                                  <div className="w-5 h-auto">
                                    {channel.icon}
                                  </div>
                                  <div className="pl-4">{channel.name}</div>
                                </div>
                              ) : (
                                <></>
                              )}

                              {channel.name ? (
                                <div className="grid content-center">
                                  <ChevronRightIcon className="w-5 h-auto" />
                                </div>
                              ) : (
                                <></>
                              )}
                            </a>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
